// extracted by mini-css-extract-plugin
module.exports = {"outlink":"OutLink_outlink___bpkA","medium":"OutLink_medium__bh8yp"};